export const checkIsALIStaff = (email: string): boolean =>
  email.includes("@acceleratelearning.com");
